import React from 'react';
import { motion } from 'framer-motion';
export function PhasesSection() {
  const phases = [{
    emoji: '🌱',
    title: 'FOLICULAR',
    subtitle: 'Semana 1',
    desc: 'Energía en ascenso, creatividad y fuerza.',
    strategy: 'Pesas + carbohidratos complejos + semillas',
    color: 'border-emerald-300/50 bg-emerald-50'
  }, {
    emoji: '☀️',
    title: 'OVULATORIA',
    subtitle: 'Semana 2',
    desc: 'Pico máximo de energía y testosterona.',
    strategy: 'HIIT + proteína alta + fermentados',
    color: 'border-amber-300/50 bg-amber-50'
  }, {
    emoji: '🍂',
    title: 'LÚTEA',
    subtitle: 'Semana 3',
    desc: 'Metabolismo +300 kcal, antojos.',
    strategy: 'Fuerza funcional + magnesio + carbohidratos de calidad',
    color: 'border-orange-300/50 bg-orange-50'
  }, {
    emoji: '❄️',
    title: 'MENSTRUAL',
    subtitle: 'Semana 4',
    desc: 'Reparación y descanso.',
    strategy: 'Movimiento suave + caldos + grasas saludables',
    color: 'border-sky-300/50 bg-sky-50'
  }];
  return <section className="w-full py-10 md:py-16 px-4 bg-[#FDF6F0]" data-id="element-88">
      <div className="max-w-6xl mx-auto" data-id="element-89">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-center mb-6 md:mb-10 text-brand-text-primary" data-id="element-90">
          Las 4 Fases de tu Poder Biológico
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5" data-id="element-91">
          {phases.map((phase, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`p-4 md:p-6 rounded-xl border ${phase.color} shadow-sm hover:shadow-md hover:scale-105 transition-all duration-300`} data-id="element-92">
              <div className="text-4xl mb-3 md:mb-4" data-id="element-93">{phase.emoji}</div>
              <h3 className="text-xl font-bold text-brand-text-primary mb-1" data-id="element-94">
                {phase.title}
              </h3>
              <p className="text-sm text-brand-text-muted mb-3 md:mb-4 uppercase tracking-wider" data-id="element-95">
                {phase.subtitle}
              </p>
              <p className="text-brand-text-body mb-3 md:mb-4 h-auto md:h-12" data-id="element-96">
                {phase.desc}
              </p>
              <div className="pt-4 border-t border-[#E8D8E0]" data-id="element-97">
                <p className="text-xs text-brand-text-muted mb-1" data-id="element-98">
                  Estrategia:
                </p>
                <p className="text-sm font-medium text-brand-purple-light" data-id="element-99">
                  {phase.strategy}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}